import { MprcLocaleType } from "components/locales/locales";

export class QuillTranslateToolbar {

    private el: Element | null;
    private theme: MprcLocaleType;

    constructor(id: string, theme: MprcLocaleType) {
        this.theme = theme;
        this.el = document.querySelector(".quill-container-editor");

        if (this.el) {
            const ed = this.el.querySelector(".ql-editor");
            if (ed) ed.setAttribute("tabindex", "0");

            const buttons = this.el.querySelectorAll(".ql-toolbar button, .ql-toolbar .ql-picker, .ql-toolbar .ql-picker .ql-picker-label");
            if (buttons) buttons.forEach((el) => el.setAttribute("tabindex", "-1"));
        }
    }

    private setToolbar(className: string, attr: string, value: string) {
        if (this.el) {
            var x = this.el.querySelector(`${className}`);
            if (x) x.setAttribute(attr, value);
        }
    }

    public translate() {
        if (!this.el) return;

        this.setToolbar(".ql-bold", "title", this.theme.MprcQuillEditor.bold);
        this.setToolbar(".ql-publication", "title", this.theme.MprcQuillEditor.publication);
        this.setToolbar(".ql-image", "title", this.theme.MprcQuillEditor.image);
        this.setToolbar(".ql-video", "title", this.theme.MprcQuillEditor.video);
        this.setToolbar(".ql-link", "title", this.theme.MprcQuillEditor.link);
        this.setToolbar(".ql-italic", "title", this.theme.MprcQuillEditor.italic);
        this.setToolbar(".ql-underline", "title", this.theme.MprcQuillEditor.underline);
        this.setToolbar(".ql-strike", "title", this.theme.MprcQuillEditor.strike);
        this.setToolbar(".ql-indent[value='-1']", "title", this.theme.MprcQuillEditor.identLeft);
        this.setToolbar(".ql-indent[value='+1']", "title", this.theme.MprcQuillEditor.identRight);
        this.setToolbar(".ql-code-block", "title", this.theme.MprcQuillEditor.blockCode);
        this.setToolbar(".ql-blockquote", "title", this.theme.MprcQuillEditor.blockQuote);
        this.setToolbar(".ql-clean", "title", this.theme.MprcQuillEditor.clearFormat);
        this.setToolbar(".ql-size", "title", this.theme.MprcQuillEditor.fontSize);
        this.setToolbar(".ql-header", "title", this.theme.MprcQuillEditor.headerSize);
        this.setToolbar(".ql-align", "title", this.theme.MprcQuillEditor.textAlign);
        this.setToolbar(".ql-background", "title", this.theme.MprcQuillEditor.bgColor);
        this.setToolbar(".ql-color", "title", this.theme.MprcQuillEditor.textColor);
        this.setToolbar(".ql-list[value='ordered']", "title", this.theme.MprcQuillEditor.orderedList);
        this.setToolbar(".ql-list[value='bullet']", "title", this.theme.MprcQuillEditor.bulletList);
        this.setToolbar(".ql-customMentions", "title", this.theme.MprcQuillEditor.mention);
        this.setToolbar(".ql-direction", "title", this.theme.MprcQuillEditor.textDirection);
        this.setToolbar(".ql-customField .ql-picker-label", "data-content", this.theme.MprcQuillEditor.customField);
    }
}
